import type { JSX } from "react";
import { PlainTooltip } from "@similarweb/ui-components";

import SWReactIcons from "app/components/React/SWReactIcons/SWReactIcons";
import { translate } from "app/filters/i18nFilter";
import {
    ListItem,
    ListItemIcon,
    ListItemName,
    ListItemNameAbbr,
    ListItemEmail,
    CloseIconButton,
    ButtonWrapper,
    TooltipWrapper,
    ListItemRoleStatus,
} from "./RestrictedOptionListItem.styled";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface IRestrictedOptionListItemProps {
    name: string;
    email: string;
    onRemoveUser?: () => void;
    isViewer?: boolean;
    isMyUser: boolean;
    roleStatus?: string;
    hideClearButton?: boolean;
    tooltipContent?: string;
}

export const RestrictedOptionListItem = ({
    name,
    email,
    onRemoveUser,
    isViewer,
    isMyUser,
    roleStatus,
    hideClearButton,
    tooltipContent = translate("dashboard.shareDashboard.users.tooltip.text"),
}: IRestrictedOptionListItemProps): JSX.Element => (
    <ListItem
        justifyContent="space-between"
        alignItems="center"
        hideClearButton={hideClearButton}
    >
        <BaseFlex alignItems="center">
            <ListItemIcon
                isViewer={isViewer}
                justifyContent="center"
                alignItems="center"
            >
                <SWReactIcons
                    iconName={isViewer ? "eye-icon-blue" : "user"}
                    size="xs"
                />
            </ListItemIcon>
            <div>
                <ListItemName>
                    {name}
                    {isMyUser ? (
                        <ListItemNameAbbr> ({translate("dashboard.shareDashboard.users.you")})</ListItemNameAbbr>
                    ) : null}
                </ListItemName>
                <ListItemEmail>{email}</ListItemEmail>
            </div>
        </BaseFlex>
        {!isMyUser && !hideClearButton ? (
            <TooltipWrapper>
                <PlainTooltip
                    tooltipContent={tooltipContent}
                    placement="top"
                    cssClass="PlainTooltip-element websiteListTypeDisabledTooltip"
                >
                    <ButtonWrapper>
                        <CloseIconButton
                            type="flat"
                            onClick={onRemoveUser}
                            iconName="clear"
                        />
                    </ButtonWrapper>
                </PlainTooltip>
            </TooltipWrapper>
        ) : null}
        {roleStatus ? <ListItemRoleStatus alwaysDisplay={hideClearButton}>{roleStatus}</ListItemRoleStatus> : null}
    </ListItem>
);
